var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.selected_eventstatus,"items":_vm.eventstatuscodes,"item-value":"code","item-text":"description","label":_vm.label,"dense":"","clearable":_vm.selection_clearable,"disabled":_vm.disabled},on:{"change":_vm.updateData}})
}
var staticRenderFns = []

export { render, staticRenderFns }